window.tinymce.PluginManager.add('effects', function(editor){
    editor.addButton('effects', () => {
        function showDialog() {
            editor.windowManager.open({
                title: window.gettext('Effects'),
                width: 734,
                height: 600,
                file: window.hashed_paths['tinymce_effects.html'],
                buttons: [],
            });
        }

        return {
            tooltip: 'Effects',
            icon: 'custom fa-tasks',
            onclick: showDialog,
        };
    });
});
